import permissions from '../permissions'

const EXTERNAL_PLATFORM_INTEGRATION_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.LIST,
    tag: permissions.EXTERNAL_PLATFORM_INTEGRATIONS.LIST,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.CREATE,
    tag: permissions.EXTERNAL_PLATFORM_INTEGRATIONS.MANAGE,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.EDIT,
    tag: permissions.EXTERNAL_PLATFORM_INTEGRATIONS.UPDATE,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.SOFT_DELETE,
    tag: permissions.EXTERNAL_PLATFORM_INTEGRATIONS.DESTROY,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.ACTIVATE_OR_INACTIVATE,
    tag: permissions.EXTERNAL_PLATFORM_INTEGRATIONS.CHANGE_STATUS,
  },
]

export default EXTERNAL_PLATFORM_INTEGRATION_LIST
